import { NgModule, LOCALE_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { AuthGuardService } from "./services/auth-guard.service";
import { AuthService } from "./services/auth.service";
import { AccountLoginComponent } from "./components/account/account-login.component";
import { AccountResetComponent } from "./components/account/account-reset.component";
import { AccountRichiestaResetComponent } from "./components/account/account-richiesta-reset.component";
import { ZoneUtenteListComponent } from "./components/utenti/zone-utente-list.component";
import { ZoneService } from "./services/zone.service";
import { DateAdapter } from "@angular/material";

import { QuillModule } from "ngx-quill";

import * as $ from "jquery";

import { Configurations } from "./core/configurations";

import {
  HttpModule,
  Http,
  BaseRequestOptions,
  XHRBackend,
} from "@angular/http";

//import {CdkTableModule} from '@angular/cdk';
import { Router } from "@angular/router";

import { GeocodingService } from "./components/google-map/geocoding.service";
import { GeolocationService } from "./components/google-map/geolocation.service";
import { MapService } from "./components/google-map/map.service";
import { GoogleMapMarkerDirective } from "./components/google-map/google-map-marker.directive";
import { GoogleMapComponent } from "./components/google-map/google-map.component";

import { PublicLayoutComponent } from "./components/layout/public-layout.component";
import { LeftMenuComponent } from "./components/layout/left-menu.component";
import { PrivateLayoutComponent } from "./components/layout/private-layout.component";

import { LocalDb } from "./core/localdb";

import { AppComponent } from "./app.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { ClientiListComponent } from "./components/clienti/clienti-list.component";
import { ClientiService } from "./services/clienti.service";
import { ClienteDetailComponent } from "./components/clienti/cliente-detail.component";
import { IncassiService } from "./services/incassi.service";
import { IncassiDettaglioService } from "./services/incassi-dettaglio.service";
import { PartiteService } from "./services/partite.service";
import { DizionariService } from "./services/dizionari.service";

import { AppRoutingModule } from "./app-routing.module";
import { BrogliacciListComponent } from "./components/brogliacci/brogliacci-list.component";
import { BrogliacciService } from "./services/brogliacci.service";
import { IncassiListComponent } from "./components/incassi/incassi-list.component";
import { DistintaContantiDialog } from "./components/incassi/distinta-contanti.component";
import { DistintaAssegniDialog } from "./components/incassi/distinta-assegni.component";
import { BrogliaccioDetailComponent } from "./components/brogliacci/brogliaccio-detail.component";
import { BrogliaccioNewDetailComponent } from "./components/brogliacci/brogliaccio-new-detail.component";

import { DistinteIncassiService } from "./services/distinte-incassi.service";
import { DistinteVersamentiService } from "./services/distinte-versamenti.service";
import { DistintaIncassiNewDetailComponent } from "./components/distinteIncassi/distinta-incassi-new-detail.component";
import { DistintaIncassiDetailComponent } from "./components/distinteIncassi/distinta-incassi-detail.component";
import { DistinteIncassiListComponent } from "./components/distinteincassi/distinte-incassi-list.component";
import { DistinteVersamentiListComponent } from "./components/distinteVersamenti/distinte-versamenti-list.component";

import { DistintaVersamentiNewDetailComponent } from "./components/distinteVersamenti/distinta-versamenti-new-detail.component";
import { DistintaVersamentiDetailComponent } from "./components/distinteVersamenti/distinta-versamenti-detail.component";

import { PublicResetLayoutComponent } from "./components/layout/public-reset-layout.component";
import { PublicRichiestaLayoutComponent } from "./components/layout/public-richiesta-layout.component";
import { PublicConfirmExpiredLayoutComponent } from "./components/layout/public-confirm-expired-layout.component";
import { UtentiListComponent } from "./components/utenti/utenti-list.component";
import { UserService } from "./services/user.service";
import { UtilitiesService } from "./services/utilities.service";

import { Datepicker } from "./components/utils/datepicker";
import { AgentiDateAdapter } from "./components/utils/agenti-date-adapter";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { ScegliZonaUVDialog } from "./components/layout/ScegliZonaUV.component";
import { ConfirmDialogComponent } from "./components/generic_dialogs/confirm-dialog/confirm-dialog.component";
import { DistintaIncassoComponent } from "./components/incassi/distinta-incasso-component";
import { LangService } from "./services/lang.services";
import { AccountConfirmationExpiredComponent } from "./components/account/account-confirmation-expired.component";
import { UltimaVersioneApplicativoClientService } from "./services/ultima-versione-applicativo-client.service";
import { DynamicComponentsModule } from "./components/utils/dynamic/dynamic.module";
import { MaterialModule } from "./modules/material.module";

import { DashboardService } from "./services/dashboard.service";
import { SharedService } from "./services/shared.service";

import { ItemTypeManagerComponent } from "./components/utils/item-type-manager/item-type-manager.component";
import { DialogCloseAskerComponent } from "./components/dialog-close-asker/dialog-close-asker.component";
import { TextFormComponent } from "./components/utils/item-type-manager/forms/text-form/text-form.component";
import { UrlFormComponent } from "./components/utils/item-type-manager/forms/iframe-form/iframe-form.component";
import { ImageFormComponent } from "./components/utils/item-type-manager/forms/image-form/image-form.component";
import { MetadataFormComponent } from "./components/utils/item-type-manager/forms/metadata-form/metadata-form.component";
import { HttpMetadataFormComponent } from "./components/utils/item-type-manager/forms/http-metadata-form/http-metadata-form.component";
import { LinkFormComponent } from "./components/utils/item-type-manager/forms/link-form/link-form.component";
import { ImageTextFormComponent } from "./components/utils/item-type-manager/forms/image-text-form/image-text-form.component";
import { AnchorFormComponent } from "./components/utils/item-type-manager/forms/anchor-form/anchor-form.component";
import { BloccoRuoloManagerComponent } from "./components/blocco-ruolo-manager/blocco-ruolo-manager.component";
import { RuoloBloccoManagerComponent } from "./components/utils/item-manager/ruolo-blocco-manager/ruolo-blocco-manager.component";
import { DocumentsFormComponent } from "./components/utils/item-type-manager/forms/documents-form/documents-form.component";
import { ImagesBloccoComponent } from "./components/utils/item-manager/images-blocco/images-blocco.component";
import { ManagerGridItemComponent } from "./components/homepage-manager/manager-grid-item/manager-grid-item.component";
import { ItemManagerComponent } from "./components/utils/item-manager/item-manager.component";
import { ItemSliderManagerComponent } from "./components/utils/item-slider-manager/item-slider-manager.component";
import { HomepageManagerComponent } from "./components/homepage-manager/homepage-manager.component";
import { ManageSliderComponent } from "./components/homepage-manager/manager-slider/manage-slider.component";
import { MetadataBloccoComponent } from "./components/utils/item-manager/metadata-blocco/metadata-blocco.component";
import { DownloadExternalFormComponent } 
from "./components/utils/item-type-manager/forms/download-external/download-external-form.component";
import { HttpDataFormComponent } from "./components/utils/item-type-manager/forms/http-data/http-data-form.component";
import { LeftMenuService } from "./components/layout/left-menu.service";
import { HttpMetadataBloccoComponent } from "./components/utils/item-manager/http-metadata-blocco/http-metadata-blocco.component";
import { PayloadFormComponent } from "./components/utils/item-type-manager/forms/payload-form/payload-form.component";
import { DownloadExternalSourceBloccoComponent } 
from "./components/utils/item-manager/download-external-source-blocco/download-external-source-blocco.component";
import { DatePickerDirective } from "./directives/datepicker.directive";
import { BusinessLineBloccoManagerComponent } 
from "./components/utils/item-manager/business-line-blocco-manager/business-line-blocco-manager.component";

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AppRoutingModule,
    MaterialModule,
    DynamicComponentsModule,
    QuillModule,
  ],
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    AccountLoginComponent,
    PublicConfirmExpiredLayoutComponent,
    AccountRichiestaResetComponent,
    AccountResetComponent,
    LeftMenuComponent,
    PrivateLayoutComponent,
    ClientiListComponent,
    DashboardComponent,
    BrogliacciListComponent,
    ClienteDetailComponent,
    IncassiListComponent,
    DistintaContantiDialog,
    DistintaAssegniDialog,
    ScegliZonaUVDialog,
    BrogliaccioDetailComponent,
    BrogliaccioNewDetailComponent,
    DistinteIncassiListComponent,
    DistintaIncassiDetailComponent,
    DistintaIncassiNewDetailComponent,
    DistinteVersamentiListComponent,
    DistintaVersamentiDetailComponent,
    DistintaVersamentiNewDetailComponent,
    UtentiListComponent,
    GoogleMapComponent,
    GoogleMapMarkerDirective,
    ZoneUtenteListComponent,
    PublicResetLayoutComponent,
    PublicRichiestaLayoutComponent,
    Datepicker,
    ConfirmDialogComponent,
    DistintaIncassoComponent,
    AccountConfirmationExpiredComponent,
    PublicConfirmExpiredLayoutComponent,
    ManagerGridItemComponent,
    ItemManagerComponent,
    ItemSliderManagerComponent,
    HomepageManagerComponent,
    ItemTypeManagerComponent,
    DialogCloseAskerComponent,
    TextFormComponent,
    UrlFormComponent,
    ImageFormComponent,
    MetadataFormComponent,
    HttpMetadataFormComponent,
    LinkFormComponent,
    ImageTextFormComponent,
    AnchorFormComponent,
    DownloadExternalFormComponent,
    HttpDataFormComponent,
    PayloadFormComponent,
    ManageSliderComponent,
    BloccoRuoloManagerComponent,
    RuoloBloccoManagerComponent,
    BusinessLineBloccoManagerComponent,
    DocumentsFormComponent,
    ImagesBloccoComponent,
    MetadataBloccoComponent,
    HttpMetadataBloccoComponent,
    DownloadExternalSourceBloccoComponent,
    DatePickerDirective
  ],
  providers: [
    MapService,
    GeolocationService,
    GeocodingService,
    PartiteService,
    ClientiService,
    IncassiService,
    IncassiDettaglioService,
    DizionariService,
    Configurations,
    BrogliacciService,
    DistinteIncassiService,
    DistinteVersamentiService,
    AuthGuardService,
    AuthService,
    UserService,
    UtilitiesService,
    UltimaVersioneApplicativoClientService,
    ZoneService,
    LangService,
    CurrencyPipe,
    DashboardService,
    SharedService,
    LeftMenuService,
    { provide: DateAdapter, useClass: AgentiDateAdapter },
    { provide: LOCALE_ID, useValue: "it-IT" },
  ],
  entryComponents: [
    DistintaContantiDialog,
    DistintaAssegniDialog,
    DistintaIncassoComponent,
    ScegliZonaUVDialog,
    ItemManagerComponent,
    ItemSliderManagerComponent,
    DialogCloseAskerComponent,
    ManageSliderComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // Diagnostic only: inspect router configuration
  constructor(router: Router) {
    //console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/app.module.ts